.search-icon{position:absolute;right:0;height:100%;z-index:100}::ng-deep .was-validated .ng-invalid+.search-icon{display:none}::placeholder{color:#d3d3d3}
/*# sourceMappingURL=search.component-ONCPITC7.css.map */
